import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Drawer } from '@percent/lemonade'
import { AccountPermissionsDrawerProps } from './AccountPermissionsDrawer.types'
import { PermissionsList } from '../permissionsList'
import styles from './AccountPermissionsDrawer.module.scss'

export function AccountPermissionsDrawer({
  isOpen,
  onClose,
  account,
  isLoading,
  assignedDomains,
  effectiveDomains,
  getGroupHref,
  assignAccountRole,
  unassignAccountRole,
  isDisabled = false,
}: AccountPermissionsDrawerProps) {
  const { t } = useTranslation()

  const handleClose = useCallback(() => {
    onClose()
  }, [onClose])

  if (!account) return null

  return (
    <Drawer
      isOpen={isOpen}
      onClose={handleClose}
      onOpen={() => undefined}
      title={account.accountName}
      position="right"
    >
      <PermissionsList
        title={t('drawer.accounts.selectTeamMemberRoles')}
        assignedDomains={assignedDomains}
        effectiveDomains={effectiveDomains}
        getGroupHref={getGroupHref}
        isLoading={isLoading}
        isDisabled={isDisabled}
        showEmptyState
        headerClassName={styles.drawerHeader}
        assignAccountRole={(roleId, domainId) =>
          assignAccountRole(account.accountId, roleId, domainId)
        }
        unassignAccountRole={(roleId, domainId) =>
          unassignAccountRole(account.accountId, roleId, domainId)
        }
      />
    </Drawer>
  )
}
